<template>
  <div>
    <vxe-toolbar>
      <template #buttons>
        <vxe-input
          v-model="filterName1"
          type="search"
          placeholder="Input a gene name"
          @keyup="searchEvent1"
        ></vxe-input>
        <!-- <vxe-button @click="exportDataEvent"
          ><a-icon type="cloud-download" /> Download</vxe-button
        > -->
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      show-overflow
      row-id="id"
      size="small"
      ref="xTable"
      :column-config="{ resizable: true }"
      :row-config="{ height: 30, isHover: true, isCurrent: true }"
      :loading="loading3"
      :data="tableData3"
      align="center"
      header-align="center"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
      :checkbox-config="{
        reserve: true,
        highlight: true,
        checkStrictly: true,
        range: true,
        trigger: 'row',
        labelField: '',
      }"
    >
      <vxe-column type="checkbox" width="40"></vxe-column>
      <vxe-column
        field="genename"
        title="Gene name"
        width="130px"
        type="html"
        :titlePrefix="{
          icon: 'vxe-icon-question-circle-fill',
          useHTML: true,
          message:
            'Click gene symbol to view the details of the perturbed gene',
        }"
      >
        <template #default="{ row }">
          <a
            v-if="row.percent != 0"
            @click="goPerturbgene(row.genename)"
            target="_blank"
            >{{ row.genename }}</a
          >
          <span v-else>{{ row.genename }}</span>
        </template>
      </vxe-column>
      <vxe-column field="ensg" title="Ensembl ID" type="html"></vxe-column>
      <vxe-column field="cell" title="NO. cells" type="html"></vxe-column>
      <vxe-column
        field="percent"
        title="Perturbation rate"
        type="html"
        :formatter="formatPercentCell"
      ></vxe-column>
      <template #empty>
        <div style="color: red; margin-top: 15px">
          <p>Please select a dataset to view available genes！</p>
        </div>
      </template>
    </vxe-table>

    <vxe-pager
      background
      size="small"
      :loading="loading3"
      :current-page="tablePage3.currentPage"
      :page-size="tablePage3.pageSize"
      :total="tablePage3.totalResult"
      :page-sizes="[10, 20, 50, 100]"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        // 'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange3"
    >
    </vxe-pager>
    <div style="margin-top: 10px">
      <a-card class="border">
        I. Selected dataset:
        <a-button type="danger"> {{ this.datasetId }} </a-button>
        <br />
        <br />
        II. Selected genes :
        <a-tag
          v-for="(index, element) in this.selectedGene"
          :key="index"
          :value="element"
          color="#108ee9"
          style="margin-top: 10px"
        >
          {{ index }}
        </a-tag>
        <br />
        <br />
        II. Setting dimensions for the output pdf file:
        <a-row :gutter="[12, 12]" style="margin-top: 10px">
          <a-col :span="12">
            <a-input type="text" addon-before="Width : " v-model="pWidth"
          /></a-col>
          <a-col :span="12">
            <a-input type="text" addon-before="Height: " v-model="pHeight"
          /></a-col>
        </a-row>
      </a-card>
    </div>
    <!-- <div style="margin-top: 10px">
      <a-card class="border"
        >2. Setting dimensions of output file:
        <a-row :gutter="[12, 12]" style="margin-top: 10px">
          <a-col :span="12">
            <a-input type="text" addon-before="Width : " v-model="pWidth"
          /></a-col>
          <a-col :span="12">
            <a-input type="text" addon-before="Height: " v-model="pHeight"
          /></a-col>
        </a-row>
      </a-card>
    </div> -->
    <div>
      <div style="margin-top: 10px; margin-bottom: 10px; float: right">
        <a-button type="danger" :disabled="disabled" @click="clearSelect"
          >Clear</a-button
        >
        <a-button type="primary" :disabled="disabled" @click="plotCor"
          >Plot</a-button
        >
      </div>
    </div>
    <a-modal
      :visible="visible"
      title="Heatmap drawn by DrawCorrHeatmap"
      :maskClosable="false"
      :destroyOnClose="true"
      :keyboard="false"
      :closable="true"
      style="margin-top: 300px"
      :width="800"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
      :cancel-button-props="{ props: { disabled: true } }"
    >
      <div
        style="
          height: 600px;

          width: 100%;
        "
      >
        <a-card style="margin-top: 10px" v-show="visible">
          <a-spin
            size="large"
            :spinning="vnplot_visible"
            :indicator="indicator"
          >
            <object :data="this.vnplotlinks" width="100%" height="500"></object>
          </a-spin>
        </a-card>
      </div>
    </a-modal>
  </div>
</template>
<script>
import axios from "axios";
import XEUtils from "xe-utils";

export default {
  props: ["datasetId"],
  data() {
    return {
      //基因选中事件
      selectedGene: [],
      visible: false,
      vnplotlinks: "",
      vnplot_visible: true,
      // 绘图长款参数
      pWidth: 7,
      pHeight: 6,
      indicator: <a-icon type="sync" style="font-size: 50px" spin />,
      /*table选中keys*/
      selectedRowKeys: [],
      /*table选中records*/
      selectionRows: [],
      //全表搜索
      filterName1: "",
      tempdata: [],
      disabled: true,
      //分页
      getdata: null, //必须要生成这个data
      loading3: false,
      tableData3: [],
      tablePage3: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0,
      },
    };
  },
  mounted() {
    this.tablePage3.currentPage = 1;
    axios
      .get("http://research.gzsys.org.cn/perturbdb/API/publications_freq.php", {
        params: { datasetId: this.datasetId },
      })
      .then((response) => {
        this.selectedGene = [];
        //清空之前选择的基因
        var filteredArray = response.data.filter(function (item) {
          return item.percent !== 0;
        });
        this.getdata = filteredArray;
        this.$refs.xTable.clearCheckboxRow();
        this.findList3(this.getdata);
      });
  },
  watch: {
    selectedGene() {
      if (this.selectedGene.length != 0) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    datasetId() {
      this.tablePage3.currentPage = 1;
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/publications_freq.php",
          {
            params: { datasetId: this.datasetId },
          }
        )
        .then((response) => {
          this.selectedGene = [];
          //清空之前选择的基因
          var filteredArray = response.data.filter(function (item) {
            return item.percent !== 0;
          });
          this.getdata = filteredArray;
          this.$refs.xTable.clearCheckboxRow();
          this.findList3(this.getdata);
        });
    },
  },
  methods: {
    clearSelect() {
      this.$refs.xTable.clearCheckboxRow();
      this.selectedGene = [];
    },
    formatPercentCell({ cellValue }) {
      return String(parseFloat(cellValue).toFixed(2)) + "%";
    },
    handleOk() {
      // this.ModalText = "The modal will be closed after two seconds";
      // this.confirmLoading = true;
      // setTimeout(() => {
      //   this.visible = false;
      //   this.confirmLoading = false;
      // }, 2000);
      this.visible = false;
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.visible = false;
    },
    //选中基因事件
    selectChangeEvent({ checked, records, reserves, row }) {
      // console.log(checked ? '勾选事件' : '取消事件')
      // console.log('当前选中的数据：' + records)
      // console.log('翻页时其他页的数据：' + reserves)
      // console.log('当前选中的数据行：' + row )
      //勾选选中时
      if (checked) {
        //第一次选数据，还未进行翻页时
        if (reserves.length == 0) {
          this.selectedRowKeys = records.map((v) => v.id);
          this.selectionRows = records;
        } else {
          //id集合，翻页存在已选中的数据时,拼接新选中的数据
          this.selectedRowKeys = [
            ...reserves.map((v) => v.id),
            ...records.map((v) => v.id),
          ];
          //数据集合，翻页存在已选中的数据时,拼接新选中的数据
          this.selectionRows = [...reserves, ...records];
        }
      } else {
        //取消选中时
        let idIndex = this.selectedRowKeys.indexOf(row.id);
        if (idIndex > -1) {
          //删除取消选中删除指定元素id
          this.$delete(this.selectedRowKeys, idIndex);
        }

        let dataIndex = null;
        for (let i = 0; i < this.selectionRows.length; i++) {
          if (this.selectionRows[i].id == row.id) {
            dataIndex = i;
            break;
          }
        }
        //删除取消选中的元素整个对象
        this.$delete(this.selectionRows, dataIndex);
      }
      //console.log(this.selectedRowKeys);
      //console.log(this.selectionRows);
      const selectT = [];
      for (let i = 0; i < this.selectionRows.length; i++) {
        selectT.push(this.selectionRows[i]["genename"]);
      }
      this.selectedGene = selectT;
    },
    //开始绘图事件
    plotCor() {
      this.visible = true;
      (this.vnplotlinks = ""),
        (this.vnplot_visible = true),
        axios
          .get(
            "http://research.gzsys.org.cn/perturbdb/API/clusters/plotCor.php",
            {
              params: {
                datasetId: this.datasetId,
                genelist: this.selectedGene.join(","),
                pWidth: this.pWidth,
                pHeight: this.pHeight,
              },
            }
          )
          .then((response) => {
            if (response.data != "failed") {
              this.vnplot_visible = false;
              this.$notification["success"]({
                message: "Job done!",
                top: "100px",
                description:
                  "congratulations, " +
                  response.data +
                  ".pdf" +
                  " now is available!",
              });
              this.vnplotlinks =
                "http://research.gzsys.org.cn/perturbdb/data/temppPlot/" +
                response.data +
                ".pdf#zoom=60";
            } else {
              this.visible = false;
              this.vnplot_visible = false;
              this.vnplotlinks = null;
              this.$message.error("Please contact us for help!", 6);
            }
          });
    },
    exportDataEvent() {
      if (this.tempdata.length != 0) {
        const list = this.tempdata;
        this.$refs.xTable.exportData({
          filename: this.filterName1 + "_related_freqTableOf_" + this.datasetId,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      } else {
        const list = this.getdata;
        this.$refs.xTable.exportData({
          filename: "FreqTableOf_" + this.datasetId,
          type: "csv",
          isHeader: true,
          isFooter: true,
          data: list,
        });
      }
    },
    goPerturbgene(value) {
      let routeData = this.$router.resolve({
        name: "perturbedgenes",
        query: { datasetId: this.datasetId, gene: value },
      });
      window.open(routeData.href, "_blank");
    },
    findList3(data) {
      this.loading3 = true;
      setTimeout(() => {
        const list = data;
        this.loading3 = false;
        this.tablePage3.totalResult = list.length;
        this.tableData3 = list.slice(
          (this.tablePage3.currentPage - 1) * this.tablePage3.pageSize,
          this.tablePage3.currentPage * this.tablePage3.pageSize
        );
      }, 300);
    },
    handlePageChange3({ currentPage, pageSize }) {
      this.tablePage3.currentPage = currentPage;
      this.tablePage3.pageSize = pageSize;
      if (this.tempdata.length == 0) {
        this.findList3(this.getdata);
      } else {
        this.findList3(this.tempdata);
      }
    },
    searchEvent1() {
      this.tablePage3.currentPage = 1; // 每次查找都定位到第一页
      const filterName = XEUtils.toValueString(this.filterName1)
        .trim()
        .toLowerCase();
      if (filterName) {
        const filterRE = new RegExp(filterName, "gi");
        const searchProps = ["genename", "ensg", "cell", "percent"];
        const rest = this.getdata.filter((item) =>
          searchProps.some(
            (key) =>
              XEUtils.toValueString(item[key])
                .toLowerCase()
                .indexOf(filterName) > -1
          )
        );
        this.tempdata = rest.map((row) => {
          const item = Object.assign({}, row);
          searchProps.forEach((key) => {
            item[key] = XEUtils.toValueString(item[key]).replace(
              filterRE,
              (match) => `${match}`
            );
          });
          return item;
        });
        this.findList3(this.tempdata);
      } else {
        this.tempdata = [];
        this.findList3(this.getdata);
      }
    },
  },
};
</script>
<style scpoed>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.border {
  border: 1.5px dotted blue;
  border-radius: 8px;
}
</style>
